export default "__VITE_ASSET__CEsUPOtd__"